import Cookie from 'js-cookie'

export default Cookie.withAttributes({
  domain: process.env.VUE_APP_COOKIE_DOMAIN,
  secure: !!process.env.VUE_APP_COOKIE_SECURE,
  sameSite: 'strict'
})
